import { CALL_API } from "redux-api-middleware";
import api from "apis/caseTimeLog";
import {
    REQUEST_CASETIMELOG_ADD,
    RECEIVE_CASETIMELOG_ADD,
    ERROR_CASETIMELOG_ADD,

    REQUEST_CASETIMELOG_UPDATE,
    RECEIVE_CASETIMELOG_UPDATE,
    ERROR_CASETIMELOG_UPDATE,

    REQUEST_CASETIMELOG_DELETE,
    RECEIVE_CASETIMELOG_DELETE,
    ERROR_CASETIMELOG_DELETE,

    REQUEST_CASETIMELOG_BYCASE,
    RECEIVE_CASETIMELOG_BYCASE,
    ERROR_CASETIMELOG_BYCASE,

    REQUEST_CASETIMELOG_PAIDLIST,
    RECEIVE_CASETIMELOG_PAIDLIST,
    ERROR_CASETIMELOG_PAIDLIST,

    REQUEST_PAYPERIOD_USERS,
    RECEIVE_PAYPERIOD_USERS,
    ERROR_PAYPERIOD_USERS,

    REQUEST_PAYPERIOD_APPROVED_GETLIST,
    RECEIVE_PAYPERIOD_APPROVED_GETLIST,
    ERROR_PAYPERIOD_APPROVED_GETLIST,

    REQUEST_CASETIMELOG_APPROVE,
    RECEIVE_CASETIMELOG_APPROVE,
    ERROR_CASETIMELOG_APPROVE,

    REQUEST_PAYPERIOD_GETLIST,
    RECEIVE_PAYPERIOD_GETLIST,
    ERROR_PAYPERIOD_GETLIST,


} from "typeConstants";
import responseHandler from "responseHandler";

const addCaseTimeLog = (newCaseTimeLog, displayResponse = true, callback = null) => {
    return dispatch => (
        dispatch({
            [CALL_API]: {
                endpoint: api.add(),
                method: "POST",
                body: JSON.stringify(newCaseTimeLog),
                types: [
                    REQUEST_CASETIMELOG_ADD,
                    {
                        type: RECEIVE_CASETIMELOG_ADD,
                        payload: (action, state, res) => {
                            res.json()
                                .then(data => {
                                    if (displayResponse) {
                                        setTimeout(() => {
                                            let message = "Case Time Log Added";
                                            responseHandler.success(message, dispatch);
                                        }, 0);
                                    }
                                    return data;
                                });
                        }
                    },
                    {
                        type: ERROR_CASETIMELOG_ADD,
                        payload: (action, state, res) => {
                            responseHandler.error(res, dispatch);
                            return addCaseTimeLog;
                        }
                    }
                ]
            }
        }).then(callback)
    );
};

const updateCaseTimeLog = (updateCaseTimeLog, updateTimeLogFunc) => {
    return dispatch => (
        dispatch({
            [CALL_API]:
            {
                endpoint: api.update(),
                method: "PUT",
                body: JSON.stringify(updateCaseTimeLog),
                types: [
                    REQUEST_CASETIMELOG_UPDATE,
                    {
                        type: RECEIVE_CASETIMELOG_UPDATE,
                        payload: (action, state, res) => {
                            res.json()
                                .then(data => {
                                    setTimeout(() => {
                                        let message = "Case Time Log Updated";
                                        responseHandler.success(message, dispatch);
                                        updateTimeLogFunc();
                                    }, 0);
                                    return data;
                                });
                        }
                    },
                    {
                        type: ERROR_CASETIMELOG_UPDATE,
                        payload: (action, state, res) => {
                            responseHandler.error(res, dispatch);
                            return addCaseTimeLog;
                        }
                    }
                ]
            }
        })
    );
};

const deleteCaseTimeLog = (id) => {
    return dispatch => (
        dispatch({
            [CALL_API]:
            {
                endpoint: api.delete(id),
                method: "DELETE",
                types: [
                    REQUEST_CASETIMELOG_DELETE,
                    {
                        type: RECEIVE_CASETIMELOG_DELETE,
                        payload: (action, state, res) => {
                            res.json()
                                .then(data => {
                                    setTimeout(() => {
                                        let message = "Case Time Log Deleted";
                                        responseHandler.success(message, dispatch);
                                    }, 0);
                                    return data;
                                });
                        }
                    },
                    {
                        type: ERROR_CASETIMELOG_DELETE,
                        payload: (action, state, res) => {
                            responseHandler.error(res, dispatch);
                        }
                    }
                ]
            }
        })
    );
};

const approveCaseTimeLog = (approvedCaseTimeLog, getUpdatedApprovedList) => {
    return dispatch => (
        dispatch({
            [CALL_API]:
            {
                endpoint: api.approve(),
                method: "POST",
                body: JSON.stringify(approvedCaseTimeLog),
                types: [
                    REQUEST_CASETIMELOG_APPROVE,
                    {
                        type: RECEIVE_CASETIMELOG_APPROVE,
                        payload: (action, state, res) => {
                            res.json()
                                .then(data => {
                                    setTimeout(() => {
                                        let message = "Case Time Log Approved";
                                        responseHandler.success(message, dispatch);
                                    }, 0);
                                    getUpdatedApprovedList();
                                    return data;
                                });
                        }
                    },
                    {
                        type: ERROR_CASETIMELOG_APPROVE,
                        payload: (action, state, res) => {
                            responseHandler.error(res, dispatch);
                            return addCaseTimeLog;
                        }
                    }
                ]
            }
        })
    );
};

const getCaseTimeLogByCase = (controlidnumber) => {
    return function (dispatch) {
        dispatch({
            [CALL_API]:
            {
                endpoint: api.getListByCase(controlidnumber),
                method: "GET",
                types: [
                    REQUEST_CASETIMELOG_BYCASE,
                    {
                        type: RECEIVE_CASETIMELOG_BYCASE,
                        payload: (action, state, res) =>
                            res.json()
                                .then(data => {
                                    return data;
                                })
                    },
                    {
                        type: ERROR_CASETIMELOG_BYCASE,
                        payload: (action, state, res) => {
                            responseHandler.error(res, dispatch);
                        }
                    }
                ]
            }
        });
    };
};


const getCaseTimeLogByUserPayPeriod = (internetUserId, payPeriodId) => {
    return function (dispatch) {

        dispatch({
            [CALL_API]:
            {
                endpoint: api.getListByUserPayPeriod(internetUserId, payPeriodId),
                method: "GET",
                types: [
                    REQUEST_CASETIMELOG_PAIDLIST,
                    {
                        type: RECEIVE_CASETIMELOG_PAIDLIST,
                        payload: (action, state, res) =>
                            res.json()
                                .then(data => {
                                    return data;
                                })
                    },
                    {
                        type: ERROR_CASETIMELOG_PAIDLIST,
                        payload: (action, state, res) => {
                            responseHandler.error(res, dispatch);
                        }
                    }
                ]
            }
        });
    };
};

const getListUsersByManagerPayPeriod = (internetUserId, payPeriodId) => {
    return function (dispatch) {
        dispatch({
            [CALL_API]:
            {
                endpoint: api.getListUsersByManagerPayPeriod(internetUserId, payPeriodId),
                method: "GET",
                types: [
                    REQUEST_PAYPERIOD_USERS,
                    {
                        type: RECEIVE_PAYPERIOD_USERS,
                        payload: (action, state, res) =>
                            res.json()
                                .then(data => {
                                    return data;
                                })
                    },
                    {
                        type: ERROR_PAYPERIOD_USERS,
                        payload: (action, state, res) => {
                            responseHandler.error(res, dispatch);
                        }
                    }
                ]
            }
        });
    };
};

const getListUsersByManagerPending = (internetUserId, fromDate, toDate) => {
    return function (dispatch) {
        dispatch({
            [CALL_API]:
            {
                endpoint: api.getListUsersByManagerPending(internetUserId, fromDate, toDate),
                method: "GET",
                types: [
                    REQUEST_PAYPERIOD_USERS,
                    {
                        type: RECEIVE_PAYPERIOD_USERS,
                        payload: (action, state, res) =>
                            res.json()
                                .then(data => {
                                    return data;
                                })
                    },
                    {
                        type: ERROR_PAYPERIOD_USERS,
                        payload: (action, state, res) => {
                            responseHandler.error(res, dispatch);
                        }
                    }
                ]
            }
        });
    };
};

const getPayPeriodList = (numberOfPayPeriods = null) => {
    return function (dispatch) {

        dispatch({
            [CALL_API]:
            {
                endpoint: api.getPayPeriodList(numberOfPayPeriods),
                method: "GET",
                types: [
                    REQUEST_PAYPERIOD_GETLIST,
                    {
                        type: RECEIVE_PAYPERIOD_GETLIST,
                        payload: (action, state, res) =>
                            res.json()
                                .then(data => {
                                    return data;
                                })
                    },
                    {
                        type: ERROR_PAYPERIOD_GETLIST,
                        payload: (action, state, res) => {
                            responseHandler.error(res, dispatch);
                        }
                    }
                ]
            }
        });
    };
};

const getApprovedPayPeriodList = (internetUserId, payPeriodId) => {
    return function (dispatch) {

        dispatch({
            [CALL_API]:
            {
                endpoint: api.getApprovedPayPeriodList(internetUserId, payPeriodId),
                method: "GET",
                types: [
                    REQUEST_PAYPERIOD_APPROVED_GETLIST,
                    {
                        type: RECEIVE_PAYPERIOD_APPROVED_GETLIST,
                        payload: (action, state, res) =>
                            res.json()
                                .then(data => {
                                    return data;
                                })
                    },
                    {
                        type: ERROR_PAYPERIOD_APPROVED_GETLIST,
                        payload: (action, state, res) => {
                            responseHandler.error(res, dispatch);
                        }
                    }
                ]
            }
        });
    };
};

export {
    addCaseTimeLog,
    updateCaseTimeLog,
    deleteCaseTimeLog,
    getCaseTimeLogByCase,
    getCaseTimeLogByUserPayPeriod,
    getListUsersByManagerPayPeriod,
    getListUsersByManagerPending,
    getPayPeriodList,
    approveCaseTimeLog,
    getApprovedPayPeriodList
};